<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="1100px"
      :fullscreen="fullscreen"
      :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">申报项目评审</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                  d-flex xs12 sm12 md12 lg7
                  v-if="proAttachments && proAttachments.length > 0"
              >
                <p class="my-1">申报材料：</p>
                <ol>
                  <li v-for="a in proAttachments" :key="a.dbid" class="pt-1">
                    <a :href="`/api/review/attachment/${a.dbid}`" target="_blank">
                      {{a.fileName}}
                      ({{a.size | fileSize }})
                    </a>
                  </li>
                </ol>
              </v-flex>


              <v-flex xs12>
                <v-autocomplete
                    label="评审指标"
                    :rules="rules.required"
                    v-model="item.reviewTplId"
                    item-text="name"
                    item-value="dbid"
                    :items="tplItems"
                    @change="onTplChange"
                    :disabled = true
                />
              </v-flex>


              <v-flex xs12>
                <v-data-table
                    class="dense"
                    :headers="headers"
                    :items="item.reviewItems"
                    hide-actions
                    :loading="fundLoading">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.index + 1}}</td>
                    <td>
                       <span :style="`padding-left: ${props.item.level-1}em`">
                        {{props.item.tplName}}
                       </span>
                    </td>

                    <td>
                       <span :style="`padding-left: ${props.item.level-1}em`">
                        {{props.item.note}}
                       </span>
                    </td>

                    <td v-if="props.item.leaf">
                      <v-text-field
                          :key="props.item.dbid"
                          :disabled="isMaxLimitReached(props.item)"
                          v-model="item.reviewItems[props.index].mark"
                          @keydown="filterAmountInput"
                          @paste="filterPaste"
                          :rules="rules.amount"
                          @change="onLeafItemChange"
                          pattern="\d*\.?\d{0,2}"
                          oninput="this.value = this.value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');"
                      />
                    </td>

                  </template>
                </v-data-table>
              </v-flex>

              <v-flex xs12>
                <v-textarea
                  label="评审意见"
                  v-model="comments"
                  counter="500"
                  :maxlength="500"
                  persistent-hint
                />
              </v-flex>

                <!--<v-flex xs12>
                <v-text-field
                    label="评审总分"
                    v-model="item.mark"
                />
              </v-flex>-->
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="onCancel">取消</v-btn>
        <v-btn color="primary" @click = "onTempSave" :disabled = "submitStatus">暂存</v-btn>
        <v-btn color="primary" @click = "onValidSubmit"  :disabled = "submitStatus">提交</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog
        scrollable
        v-model="confirmSubmit"
        max-width="500px"
        :persistent="true"
    >
      <v-card>
        <v-toolbar flat dense>
          <v-toolbar-title class="subheading">专家评审结果提交</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex>
                <div>评审结果提交后将不能再修改，确认提交！</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click = "confirmSubmit = false" >返回</v-btn>
          <v-btn color="primary" @click = "onSubmit">确认提交</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
const baseUri = '/api/proj/review-mark'
const tplURI =  '/api/proj/review-template'
const baseURI = '/api/proj/prereview';
const submitUri = '/api/proj/review-mark/submit'
export default {
  name: "ProjMark",
  props: ['mark','projId','reviewId','templateId','expertId','ifAnonymousLooseLeaf'],
  data() {
    return {
      visible: false,

      fullscreen : false,
      item: {},
      projItem: {},
      formValid: false,
      fundLoading: false,

      reviewTempItems: [],
      tplItems: [],

      freshItem: {
        "reviewId": null,
        "projectId": null,
        "expertId": null,
        "templateId": null,
        "mark": 0.0,
        "reviewItems": []
      },

      curReviewId: null,
      curProjId: null,
      curExpertId: null,
      proAttachments: [],

      comments: '',

      submitStatus: false,

      totalWeight: 0.0,

      confirmSubmit:false,

      headers: [
        {text: '#', sortable: false, value: 'rank', width: 18},
        {text: '指标', sortable: false, value: 'tpl_name'},
        {text: '说明', sortable: false, value: 'tpl_note'},
        {text: '评分', sortable: false, value: 'weight', width: 200},
        // {text: '备注', sortable: false, value: 'note', width: 230},
      ],

      /**
       * 验证规则
       */
      rules: {
        required: [
          v => !!v || '必填项。'
        ],
        amount: [
          v => v !== null && v !== undefined && v !== '' || '必填项。',
          v => (/^\d*\.?\d{0,2}$/).test(v) || '只能填写数字，小数点后最多保留2位。'
        ],
      }

    }
  },

  watch: {
    mark(mark) {
      window.console.log("监听mark")
      this.visible = mark
    },
    projId(projId) {
      window.console.log("进入评审界面")
      this.curProjId = projId
      this.axios.all([
        this.axios.get(`${baseURI}/${projId}`),
        this.axios.get(`${baseUri}/${this.reviewId}/${this.curProjId}/${this.curExpertId}`),
        this.axios.get(`${baseUri}/comment/${this.reviewId}/${this.curProjId}/${this.curExpertId}`)
      ]).then(
          this.axios.spread(
              (rsp, rspMark, rspComment) => {
                this.projItem = rsp.data;
                this.proAttachments = this.projItem.attachments
                window.console.log(rspComment.data.items)
                if(rspComment.data.items.length > 0)
                  this.comments = rspComment.data.items[0].comments
                else
                  this.comments = ''
                if (this.ifAnonymousLooseLeaf === '是') {
                  //this.proAttachments.splice(this.proAttachments.findIndex(item => item.fileName.includes('匿名活页')))
                  this.proAttachments = this.proAttachments.filter(item => item.fileName.includes('匿名活页'))
                }

                this.items = rspMark.data
                if(this.items.length > 0)
                {
                  for (let j = 0; j < this.items.length; j++) {
                    this.item.reviewItems[j].mark = this.items[j].mark
                    if (this.items[0].isSubmit.includes("T"))
                      this.submitStatus = true
                    else
                      this.submitStatus = false
                  }
                }
                else
                {
                  this.item.reviewItems.forEach(v => v.mark = '')
                }
              }
          )
      )

    },
    expertId(expertId) {
      this.curExpertId = expertId
    },
    reviewId(reviewId) {
      this.curReviewId = reviewId
    },
    templateId(templateId) {
      //获取评审模版

      this.axios.get(tplURI, {
        params: {limit: 65535, dbid: templateId, sort: 'rank.asc'}
        // params: {limit: 65535, sort: 'rank.asc'}
      }).then(
          rsp => {
            //获取所有评审模版
            this.tplItems = rsp.data.items
            window.console.log("获取评审模版！")

            //对评审模版选择下拉列表指定当前模版以获取该模版指标项
            this.onTplChange(templateId)
            this.item.reviewTplId = templateId

          }
      )

    }
  },
  methods:{
    isMaxLimitReached(v){
      if (v.mark > v.weight) {
        alert("输入的评分大于该指标评分上线，请重新输入！")
        v.mark = 0
      }
      return false
    },

    onTplChange(v, ov) {
      //评审模版列表框选择，根据模版ID（v代表）获取模版树，并将模版树传递至top2down，传递参数为模版id和该模版下的所有子节点对象
       //window.console.log(`in onTplChange， v: ${v}, ov:${ov}`);

      // 新建
      this.freshItem.projectId = this.projId
      this.freshItem.reviewId = this.curReviewId
      this.freshItem.templateId = this.templateId
      this.item = window.xutil.clone(this.freshItem);

      if (!ov && v && this.item.reviewItems.length === 0) {
        // window.console.log(`in onTplChange， new`);
        this.axios.get(`${tplURI}/detail/${v}`)
            .then(rsp =>
                this.top2down(v, rsp.data.map(v => {
                  window.console.log("查询返回的模版树！")
                  return {
                    "reviewTplId": v.dbid,
                    "tplParentId": v.parentId,
                    "tplName": v.name,
                    "rank": v.rank,
                    "level": v.level,
                    "leaf": v.leaf,
                    "weight": v.weight,
                    "note": v.note,
                  }
                }))
            )
      }
    },

    onLeafItemChange() {
      // window.console.log("in onLeafItemChange");
      this.$refs.formRef.validate();
      this.top2down(this.item.reviewTplId, this.item.reviewItems)
      // window.console.log("in onLeafItemChange");
    },

    top2down(tplId, tplItems) {
      if (!tplId) return;

      const am = {}; // 父节点经费
      am[tplId] = Number(0.0);

      this.item.reviewItems = tplItems.reverse().map(
          v => {
            if (v.leaf) {
              if (v.mark === undefined) {
                v.mark = 0.0;
              }
            } else {
              v.mark = am[v.reviewTplId]
            }

            // 累加父节点金额
            if (am[v.tplParentId] === undefined)
              am[v.tplParentId] = Number(v.mark);
            else
              am[v.tplParentId] = Number(am[v.tplParentId]) + Number(v.mark);

            return v;
          }
      ).reverse();

      for (let j = 0; j < this.item.reviewItems.length; j++) {
        this.totalWeight = this.totalWeight + this.item.reviewItems[j].weight
      }

      this.item.mark = am[tplId];
      this.$forceUpdate();
    },

    onTempSave() {
      if (this.$refs.formRef.validate()) {
        if (this.item.mark <= this.totalWeight) {
          let tItem = []
          this.item.reviewId = this.reviewId
          this.item.templateId = this.templateId
          this.item.projectId = this.projId
          this.item.expertId = this.expertId
          this.item.comments = this.comments
          this.axios.post(baseUri, this.item)
              .then(rsp => {
                tItem = rsp.data
                this.visible = false;
                this.$emit('ok');
              })
              .finally(ex => {
                    if (ex) window.console.error(ex);
                  }
              )
        } else
          alert("评分综合大于模版总权重，请重新输入评分！")
      }
    },

    onValidSubmit() {
      if (this.$refs.formRef.validate()) {
        this.confirmSubmit = true
      }
    },

    onSubmit() {
        if (this.item.mark <= this.totalWeight) {
          let titem = []
          this.item.reviewId = this.reviewId
          this.item.projectId = this.projId
          this.item.expertId = this.expertId
          this.item.templateId = this.templateId
          this.axios.post(submitUri, this.item)
              .then(rsp => {
                titem = rsp.data
                this.visible = false
                this.confirmSubmit = false
                this.submitStatus = true
                this.$emit('ok');
              })
              .finally(ex => {
                    if (ex) window.console.error(ex);
                  }
              )
        } else
          alert("评分综合大于模版总权重，请重新输入评分！")
    },

    onCancel() {
      this.$emit('ok');
    },

    filterAmountInput(event) {
      const allowedControlKeys = [8, 9, 13, 16, 17, 18, 20, 27, 37, 38, 39, 40, 46];

      // 允许的字符: 数字、小数点
      const allowedChars = /^[\d.]$/;

      // 检查是否是控制键
      if (allowedControlKeys.includes(event.keyCode)) {
        return; // 允许控制键
      }

      // 检查是否是复制粘贴操作 (Ctrl+C/Ctrl+V)
      if (event.ctrlKey && (event.keyCode === 67 || event.keyCode === 86)) {
        return; // 允许复制粘贴，但需要在paste事件中处理
      }

      // 检查输入的字符是否合法
      const char = String.fromCharCode(event.keyCode);
      if (!allowedChars.test(char)) {
        event.preventDefault();
        return;
      }

      // 额外检查小数点
      const currentValue = event.target.value;
      if (char === '.' && currentValue.indexOf('.') !== -1) {
        event.preventDefault(); // 禁止输入多个小数点
      }
    },

    // 处理粘贴事件
    filterPaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData('text');

      // 验证粘贴内容是否只包含数字和小数点
      if (!/^[\d.]*$/.test(pastedText)) {
        event.preventDefault();
      }

      // 检查是否已经有小数点
      const currentValue = event.target.value;
      if (currentValue.indexOf('.') !== -1 && pastedText.indexOf('.') !== -1) {
        event.preventDefault();
      }
    }

  }
}
</script>

<style scoped>

</style>